<template>
  <ui-dialog
    v-model="isOpen"
    max-width="1000"
    :closable="false"
    custom-class="business-adresses-dialog"
  >
    <template #header>
      <div class="flex-fill">
        <h3>
          {{
            $t(
              "message.companyProfile.listings.deleteBusinessAddressesListDialog.title"
            )
          }}
        </h3>
      </div>
    </template>

    <BusinessAddressesTable
      :businessAddresses="businessAddresses"
      :isDeleteMode="true"
      @selected="selectedBusinessAddresses = $event"
    ></BusinessAddressesTable>

    <SectionLoader :status="loadingImportButton" :opacity="1" />

    <template #actions>
      <div class="d-flex justify-space-between flex-fill">
        <ui-button
          color="primary"
          outlined
          @click="handleClose"
          class="mx-2"
          :disabled="loadingImportButton"
        >
          {{ $t("message.common.cancel") }}
        </ui-button>
        <ui-button
          color="primary"
          :loading="loadingImportButton"
          :disabled="selectedBusinessAddresses.length === 0"
          class="mx-2"
          @click="handleImportClick"
        >
          {{ $t("message.common.deletePicked") }}
        </ui-button>
      </div>
    </template>
  </ui-dialog>
</template>

<script>
import BusinessAddressesTable from "@/components/ListingsConfiguration/BusinessAddressesTable.vue";
import SectionLoader from "@/components/Loader/SectionLoader";

export default {
  name: "ListingsConfigurationDeleteBusinessAddressesDialog",
  components: {
    BusinessAddressesTable,
    SectionLoader
  },
  props: {
    businessAddresses: {
      type: Object,
      required: true
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    loadingImportButton: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedBusinessAddresses: []
    };
  },

  methods: {
    handleClose() {
      this.selectedBusinessAddresses = [];
      this.$emit("close", false);
    },

    handleImportClick() {
      this.$emit("handleClick", this.selectedBusinessAddresses);
    }
  }
};
</script>
